import PropTypes from 'prop-types'
import { FormModal, FormModalFooter } from '@components/branded-modal'

/**
 * CAR-4050: the scheduler's pop-ups (Send Updates, Cancel Appointment, Select Date, Unsaved Changes, ...) on
 * the standard pop-up - FormModal + FormModalFooter - instead of a separate dialog style. Props and the
 * onClose({ type: 'close' | 'confirm' }) contract are unchanged, so its screens need no edits. Per-button
 * configs are accepted but no longer restyle the buttons: every pop-up shares one footer.
 * `clientMayEdit`: client users manage their own appointments here, so the pop-up stays usable for them.
 */
export const AdsCustomModal = ({
  title,
  open,
  description = '',
  onClose,
  children,
  titleConfig = {},
  successButtonTitle = '',
  cancelButtonTitle = '',
  hideCloseIcon = false
}) => {
  const handleClose = () => onClose?.({ type: 'close' })
  const handleConfirm = () => onClose?.({ type: 'confirm' })
  const hasFooter = Boolean(successButtonTitle || cancelButtonTitle)

  return (
    <FormModal
      open={open}
      onClose={handleClose}
      title={
        titleConfig?.startIcon ? (
          <span className='inline-flex items-center gap-2'>
            {titleConfig.startIcon}
            {title}
          </span>
        ) : (
          title
        )
      }
      icon={titleConfig?.icon}
      hideClose={hideCloseIcon}
      width='max-w-[512px]'
      clientMayEdit
      footer={
        hasFooter ? (
          <FormModalFooter
            onCancel={cancelButtonTitle ? handleClose : undefined}
            cancelLabel={cancelButtonTitle}
            onConfirm={successButtonTitle ? handleConfirm : undefined}
            confirmLabel={successButtonTitle}
          />
        ) : undefined
      }
    >
      {description && <div className='text-[13px] leading-5 text-[#334155]'>{description}</div>}
      {children && <div className={description ? 'mt-3' : ''}>{children}</div>}
    </FormModal>
  )
}

AdsCustomModal.propTypes = {
  title: PropTypes.node.isRequired,
  open: PropTypes.bool.isRequired,
  description: PropTypes.node,
  onClose: PropTypes.func.isRequired,
  children: PropTypes.node,
  titleConfig: PropTypes.object,
  successButtonTitle: PropTypes.node,
  successButtonConfig: PropTypes.object,
  cancelButtonTitle: PropTypes.node,
  cancelButtonConfig: PropTypes.object,
  hideCloseIcon: PropTypes.bool
}
